/**
 * @generated SignedSource<<74be6a77fcd61e39a494df32c05a89ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleAuthorDetailsContent$data = {
  readonly authors: ReadonlyArray<{
    readonly bio: string | null;
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"authorCardAuthor">;
  } | null> | null;
  readonly " $fragmentType": "articleAuthorDetailsContent";
};
export type articleAuthorDetailsContent$key = {
  readonly " $data"?: articleAuthorDetailsContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleAuthorDetailsContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleAuthorDetailsContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Author",
      "kind": "LinkedField",
      "name": "authors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "authorCardAuthor"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bio",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "d18b60c58a01ef78901163125b85057c";

export default node;
